import { markRaw, type Component } from "vue";

/**
 * Keep component-valued icons out of Vue's reactive proxying when they are
 * stored inside reactive state. Emoji/string icons pass through unchanged.
 */
export const nonReactiveIcon = (
  icon: Component | string
): Component | string => (typeof icon === "string" ? icon : markRaw(icon));
